import { AfterViewInit, CSP_NONCE, Component, ElementRef, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Observable, Subscription, delay, interval, map, of, startWith } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { DeviceService } from 'src/app/services/device.service';
import { Chart } from 'chart.js/auto';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {CommonModule, NgFor} from '@angular/common';
import {NgIf} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import {FormControl, FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {Inject} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { Router } from '@angular/router';
import { Error429Service } from 'src/app/services/error429.service';
import { addDays } from 'date-fns';
import { UserDataService } from 'src/app/services/user-data.service';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { es } from 'date-fns/locale';
export interface dispositivosConAlarmasInterface {
  created_at: string;
  dev_reference: string;
  dev_label: string,
  status: string,
}
interface Dispositivo{
  value: number;
  name: string;
  reference: string;
}
@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.css']
})
export class HomeContentComponent implements OnInit, OnDestroy{

  establecimientos: any =[];
  userDevices: any[] = [];
  userDevicesOriginal: any[] = [];
  devicesReferences: string = ""; //String con los dispositivos de los que necesitamos información
  nDispositivos: number = 0; //Número de dispositivos que el usuario puede visualizar
  nAlarmas: number = 0; //Suma total de las alarmas
  nAlarmasSinPresion: number = 0;
  datosRecibidos1: boolean = false; 
  datosRecibidos2: boolean = false; 
  datosRecibidos3: boolean = false; 
  disablePaginator: boolean = false;
  devicesReferencesPagina: string = "";
  devicesDataPagina: any = [];
  //datosRecibidos4: boolean = false; 
  errorMessage : string =""; //Mensaje de error
  opened: boolean[] = []; // Booleans que indican si la tabla con las gráficas debe estar visible u oculta
  charts: Chart[] = []; //Información de los charts para poder eliminarlos
  spanGaps: number = 1000 * 60 * 25; //25 minutos
  dispositivosConAlarmas: {
    created_at: any; 
    dev_reference: any; 
    dev_label: any; 
    est_name: any,
    dev_id: any; 
    device_lastReader: any;
    status: any, 
    type: any, 
    backgroundColor: any,
    est_id: any,
    tank: any,
    tankJson: any,
    tank_num: any,
    tank_id: any,
    nivel_actual: any,
    tank_capacity: any,
    tank_beertype: any,
    external_id: any,
    fieldNivel: any
  } [] = [];
  dispositivosConAlarmasNivel: any = [];
  //Colores de las gráficas
    gradientStroke: any;
    gradientStroke2: any;
    gradientStroke3: any;
    gradientFill: any;
    gradientFill2: any;
    gradientFill3: any;
  //Reloj
    time = new Date();
    intervalId: any;

  //RITMO CONSUMOS
  private ritmosConsumoSubscription: Subscription | undefined;

  //AUTOCOMPLETE
    myControl = new FormControl<string | Dispositivo>('');
    filteredOptions!: Observable<Dispositivo[]>;
    dispositivosAutocomplete: Dispositivo[] = [];
    dispositivoBuscadoBoolean: boolean = false;
    dispositivoBuscado: any;
  
  //ACTUALIZAR
    intervalIdActualzar: any;
    chartT : any;
    chartP : any;
    chartNC: any;
    tamañoHistorial: number = 0;

    //CONTADORES
    contadorAlarmaTemperatura = 0
    contadorAlarmaNivel = 0
    contadorAlarmaConexion = 0
    contadorAlarmaPresion = 0
    contadorOtras = 0
    nEstablecimientos: number = 0; //Número de establecimientos que el usuario puede visualizar

  //ENSEÑAR UNIDADES
  /*-------------------------------FechaActual-------------------------------------------*/
  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate(); // Obtener el día del mes actual
  mes: number = this.fechaActual.getMonth(); // Los meses comienzan en 0, por lo que enero es 0 y diciembre es 11)
  anio: number = this.fechaActual.getFullYear(); // Obtener el año actual
  nombresMeses: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  nombreMes: string = this.nombresMeses[this.mes];

  sFechaActual: string = this.dia+ " de " +this.nombreMes+ " de " +this.anio;
  /*-------------------------------FechaActual------------------------------------------*/

  /*-------------------------------FechaActualConGuiones------------------------------------------*/
  fechaActualD = new Date();
  mes1 = this.mes + 1; // Los meses comienzan desde 0, por lo que se suma 1
  fechaFormateada = `${this.anio}-${this.mes1.toString().padStart(2, '0')}-${this.dia.toString().padStart(2, '0')}`;
  /*-------------------------------FechaActualConGuiones------------------------------------------*/

  /*-------------------------------Suscripciones------------------------------------------*/
  private userDevicesDataSubscription: Subscription | undefined;
  private deviceTodayHistorySubscriptions: Subscription[] = [];
  /*-------------------------------Suscripciones------------------------------------------*/

  /*-------------------------------Paginacion------------------------------------------*/
  visibleDevices: any[] = []; // Lista paginada de dispositivos visibles
  firstPageSize = 20; //Tamaño de la primera página
  pageSize = this.firstPageSize; // Cantidad de dispositivos por página
  currentPage = 0; // Página actual
  currentPageDevices: any[] = [];
  deviceHistoryMap: { [deviceReference: string]: any } = {}; //Historial de los dispositivos
  /*-------------------------------Paginacion------------------------------------------*/

  //FILTROS DE DISPOSITIVOS
  selectedStatus: string = 'todos';
  updateVisibleDevicesActualizacion: boolean = true;

  userData: any;
  
  constructor(private deviceService: DeviceService, private userService: UserService, public dialog: MatDialog, 
    private router: Router, private error429: Error429Service, private userDataService: UserDataService,
    @Inject(CSP_NONCE) public cspNonce: string){
      this.userData = this.userDataService.getUserData();
  }

  openDialog(enterAnimationDuration: string, exitAnimationDuration: string): void {
    //const alarmas: dispositivosConAlarmas;
    this.dialog.open(DialogAnimationsExampleDialog, {
      data: this.dispositivosConAlarmas,
      width: '500px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }

  // abrirDialogoTanques(enterAnimationDuration: string, exitAnimationDuration: string){
  //   this.dialog.open(TanquesConAlarmaDeNivelDialog, {
  //     data: {
  //       tanquesConAlarmasNivel: this.dispositivosConAlarmasNivel,
  //       establecimientos: this.establecimientos
  //     },
  //     width: '700px',
  //     enterAnimationDuration,
  //     exitAnimationDuration,
  //   });
  // }
  
  ngOnInit(): void {
    /*of(true).pipe(
      delay(3000) // Retrasar la emisión durante 3 segundos
    ).subscribe(() => {*/
    this.userDevicesDataSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next: resp =>{
        this.userDevices = resp;
        console.log(resp);
        for(let i=0; i<resp.length; i++){
          this.establecimientos.push(resp[i].establishment);
        }
        const idUnicos: any = {};

        // Filtrar los establecimientos basándote en su id
        this.establecimientos = this.establecimientos.filter((establecimiento: any) => {
          if (!idUnicos[establecimiento.id]) {
            idUnicos[establecimiento.id] = true;
            return true;
          }
          return false;
        });
        //Ordenar los establecimientos por fecha de mayor a menor
        this.userDevices.sort((a: any, b: any) => a.dev_label.localeCompare(b.dev_label));
        /*this.userDevices.sort((a, b) => {
          const dateA = new Date(a.lastreader.created_at);
          const dateB = new Date(b.lastreader.created_at);
          return dateB.getTime() - dateA.getTime();
        });*/
        //Excluir los devices que no estén activos
        this.userDevices = this.userDevices.filter(device => device.dev_status === 1);
        this.nDispositivos = this.userDevices.length;
        this.userDevicesOriginal =  this.userDevices;
        this.contadorAlarmaTemperatura = 0
        this.contadorAlarmaNivel = 0
        this.contadorAlarmaConexion = 0
        this.contadorAlarmaPresion = 0
        this.contadorOtras = 0
        this.calcularDispositivosAutocompleteOriginal();
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            const name = typeof value === 'string' ? value : value?.name;
            return name ? this._filter(name as string) : this.dispositivosAutocomplete.slice();
          }),
        );
        //console.log(this.dispositivosAutocomplete);
        /*Cargamos los datos y las gráficas de los dispositivos de la primera página,
        luego ya se actualizan si es necesario en la función onPageChange*/
        //Poner los paneles abiertos
        for(let i=0; i<this.userDevices.length; i++ ){
          this.opened.push(true);
          /*if(this.verificarExistenciaHistorial(this.deviceHistoryMap,this.userDevices[i].dev_reference)){
            this.opened.push(true);
          }*/
          for(let j=0; j<this.userDevices[i].alarms.length; j++){
            this.nAlarmas ++;
            this.getContadorPorAlarma(this.userDevices[i].alarms[j].type)
            const backgroundColor = this.getColorByTipoAlarma(this.userDevices[i].alarms[j].type);
            let tankJson = JSON.parse(this.userDevices[i].alarms[j].tank);
            let fieldNivel = "";
            let actualtank;
            if(tankJson){
              if(tankJson.custom_num == 1){
                fieldNivel = "field17"
              }
              if(tankJson.custom_num == 2){
                fieldNivel = "field18"
              }
              if(tankJson.custom_num == 3){
                fieldNivel = "field19"
              }
              if(tankJson.custom_num == 4){
                fieldNivel = "field25"
              }
              for(let x=0; x<this.userDevices[i].tanks.length; x++){
                if(tankJson.custom_num == this.userDevices[i].tanks[x].custom_num){
                  actualtank = this.userDevices[i].tanks[x];
                }
              }
            }
            const fecha = new Date(this.userDevices[i].alarms[j].started_at);
            const fechaFormateada = fecha.toLocaleString(this.userData.region);
            this.dispositivosConAlarmas.push({
              created_at: fechaFormateada,
              dev_reference: this.userDevices[i].dev_reference,
              dev_label: this.userDevices[i].dev_label,
              est_name: this.userDevices[i].establishment.est_name,
              external_id: this.userDevices[i].establishment?.external_id,
              dev_id: this.userDevices[i].id,
              device_lastReader: this.devolverDispositivo(this.userDevices[i].alarms[j].device_id).lastreader,
              status : this.userDevices[i].alarms[j].desc2,
              type: this.userDevices[i].alarms[j].type,
              backgroundColor: backgroundColor,
              est_id: this.userDevices[i].establishment.id,
              tank: this.userDevices[i]?.alarms[j]?.tank,
              tankJson: tankJson,
              tank_num: tankJson?.custom_num,
              tank_id: tankJson?.id,
              nivel_actual: this.userDevices[i].lastreader[fieldNivel],
              tank_capacity: tankJson?.capacity,
              tank_beertype: actualtank?.beertype.name,
              fieldNivel: fieldNivel
            });
          }
        }
        this.nAlarmasSinPresion = this.nAlarmas - this.contadorAlarmaPresion
        this.dispositivosConAlarmasNivel = this.dispositivosConAlarmas.filter(item => item.type === 'L1' || item.type === 'L2' || item.type === 'L3' || item.type === 'L4' );
        this.updateVisibleDevices();
          //El string devicesReferences guarda los dev_reference entre guiones
          /*for(let i=0; i<this.userDevices.length; i++ ){
            if(i<this.userDevices.length-1){
              this.devicesReferences += this.userDevices[i].dev_reference + '-';
            } else{
              this.devicesReferences += this.userDevices[i].dev_reference;
            }
          }*/
          /*this.devicesDataSubscription = this.deviceService.getDevicesData(this.devicesReferences).subscribe({
            next: resp => {
              this.devicesData = resp;
              for(let i=0; i<this.devicesData.length; i++){
                let valor = Number(this.devicesData[i].field0); //Con Number() convertimos el string en number
                this.nAlarmas += valor;
                if(valor == 1){
                  //Conseguir el dev_reference y el dev_label del dispositivo que lanza la alarma
                  for(let j=0; j<this.userDevices.length; j++){
                    if(this.devicesData[i].id === this.userDevices[j].id){
                      this.dispositivosConAlarmas.push({
                        created_at: this.devicesData[i].created_at,
                        dev_reference: this.userDevices[j].dev_reference,
                        dev_label: this.userDevices[j].dev_label,
                        status : this.devicesData[i].status
                      });
                    }
                  }
                }
              }
            },error:err =>{
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            },complete:()=>{
              this.datosRecibidos3 = true;    
            }
          });*/
      },error:err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },complete:()=>{   
      }
    });
    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);
    this.intervalIdActualzar = setInterval(() => {
      this.actualizarDatosDevices();
      //console.log(this.deviceHistoryMap);
    }, 15000);
  }

  getContadorPorAlarma(tipoAlarma: string) {
    const temperaturTypes = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
    const presionTypes = ['D1', 'D2', 'D3', 'D4', 'C1', 'C2', 'C3', 'C4'];
    const nivelConsumoTypes = ['L1', 'L2', 'L3', 'L4'];
    const dispositivoTypes = ['TT', 'EE'];
    const dispositivoDesconectado = ['OO'];
  
    if (temperaturTypes.includes(tipoAlarma)) {
      this.contadorAlarmaTemperatura ++;
    } else if (presionTypes.includes(tipoAlarma)) {
      this.contadorAlarmaPresion ++;
    } else if (nivelConsumoTypes.includes(tipoAlarma)) {
      this.contadorAlarmaNivel ++;
    } else if (dispositivoDesconectado.includes(tipoAlarma)) {
      this.contadorAlarmaConexion ++;
    }else if (dispositivoTypes.includes(tipoAlarma)) {
      this.contadorOtras ++;
    }
  }
  //AUTOCOMPLETE
    private _filter(name: string): Dispositivo[] {
      const filterValue = name.toLowerCase();
      return this.dispositivosAutocomplete.filter((option: any) => option.name.toLowerCase().includes(filterValue));
    }

    displayFn(dispositivo: Dispositivo): string {
      return dispositivo && dispositivo.name ? dispositivo.name : '';
    }

    onOptionSelected(event: MatAutocompleteSelectedEvent): void {
      const selectedDispositivo: string | Dispositivo | null = this.myControl.value;
      console.log(selectedDispositivo);
      if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
        this.dispositivoBuscadoBoolean = true;
        this.dispositivoBuscado = selectedDispositivo;
        this.userDevices = [this.devolverDispositivo(selectedDispositivo.value)];
        this.currentPage = 0;
        this.nDispositivos = this.userDevices.length;
        this.devicesDataPagina = [];
        this.updateVisibleDevicesActualizacion = false;
        this.actualizarDatosDevices();
        this.updateVisibleDevices();
        this.updateVisibleDevicesActualizacion = true;
      }
    }

    limpiarSeleccion(): void {
      this.dispositivoBuscadoBoolean = false;
      this.myControl.setValue('');
      this.userDevices = this.userDevicesOriginal;
      this.currentPage = 0;
      this.nDispositivos = this.userDevices.length;
      this.devicesDataPagina = [];
      this.updateVisibleDevicesActualizacion = false;
      this.actualizarDatosDevices();
      this.updateVisibleDevices();
      this.updateVisibleDevicesActualizacion = true;
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => {
          const name = typeof value === 'string' ? value : value?.name;
          return name ? this._filter(name as string) : this.dispositivosAutocomplete.slice();
        }),
      );
    }

    calcularDispositivosAutocompleteOriginal(){
      let autocomplete = [];
      for(let i=0; i<this.userDevicesOriginal.length; i++){
        autocomplete.push({
          value: this.userDevicesOriginal[i].id,
          name: this.userDevicesOriginal[i].dev_label,
          reference: this.userDevicesOriginal[i].dev_reference
        });
      }
      this.dispositivosAutocomplete = autocomplete;
    }

  vaciarContenidoDeviceHistoryMap() {
    // Iterar sobre las referencias de dispositivos
    for (const deviceReference in this.deviceHistoryMap) {
      if (this.deviceHistoryMap.hasOwnProperty(deviceReference)) {
        this.deviceHistoryMap[deviceReference] = {};
      }
    }
  }

  actualizarDatosDevices(){
    this.dispositivosConAlarmas = [];
    this.userDevicesDataSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next: resp =>{
        //console.log(resp);
        for(let i=0; i<resp.length; i++){
          for(let j=0; j<this.userDevices.length; j++){
            if(resp[i].id == this.userDevices[j].id){
              this.userDevices[j] = resp[i];
            }
          }
        }
        this.userDevices = this.userDevices.filter(device => device.dev_status === 1);
        this.nDispositivos = this.userDevices.length;
          for(let i=0; i<this.userDevices.length; i++ ){
            this.opened.push(true);
            for(let j=0; j<this.userDevices[i].alarms.length; j++){
              const backgroundColor = this.getColorByTipoAlarma(this.userDevices[i].alarms[j].type);
              let tankJson = JSON.parse(this.userDevices[i].alarms[j].tank);
              let fieldNivel = "";
              let actualtank;
              if(tankJson){
                if(tankJson.custom_num == 1){
                  fieldNivel = "field17"
                }
                if(tankJson.custom_num == 2){
                  fieldNivel = "field18"
                }
                if(tankJson.custom_num == 3){
                  fieldNivel = "field19"
                }
                if(tankJson.custom_num == 4){
                  fieldNivel = "field25"
                }
                for(let x=0; x<this.userDevices[i].tanks.length; x++){
                  if(tankJson.custom_num == this.userDevices[i].tanks[x].custom_num){
                    actualtank = this.userDevices[i].tanks[x];
                  }
                }
              }
              const fecha = new Date(this.userDevices[i].alarms[j].started_at);
              const fechaFormateada = fecha.toLocaleString(this.userData.region);
              this.dispositivosConAlarmas.push({
                created_at: fechaFormateada,
                dev_reference: this.userDevices[i].dev_reference,
                dev_label: this.userDevices[i].dev_label,
                est_name: this.userDevices[i].establishment.est_name,
                external_id: this.userDevices[i].establishment?.external_id,
                dev_id: this.userDevices[i].id,
                device_lastReader: this.devolverDispositivo(this.userDevices[i].alarms[j].device_id).lastreader,
                status : this.userDevices[i].alarms[j].desc2,
                type: this.userDevices[i].alarms[j].type,
                backgroundColor: backgroundColor,
                est_id: this.userDevices[i].establishment.id,
                tank: this.userDevices[i]?.alarms[j]?.tank,
                tankJson: tankJson,
                tank_num: tankJson?.custom_num,
                tank_id: tankJson?.id,
                nivel_actual: this.userDevices[i].lastreader[fieldNivel],
                tank_capacity: tankJson?.capacity,
                tank_beertype: actualtank?.beertype.name,
                fieldNivel: fieldNivel
              });
            }
          }
        this.nAlarmas = this.dispositivosConAlarmas.length;
        this.dispositivosConAlarmasNivel = this.dispositivosConAlarmas.filter(item => item.type === 'L1' || item.type === 'L2' || item.type === 'L3' || item.type === 'L4' );
        if(this.updateVisibleDevicesActualizacion){
          this.updateVisibleDevicesActualización();
        }
        },error:err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        },complete:()=>{}
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    clearInterval(this.intervalIdActualzar);
    if (this.userDevicesDataSubscription) {
      this.userDevicesDataSubscription.unsubscribe();
    }
    this.deviceTodayHistorySubscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  //Funciones para actualizar la página actual
  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //ALARMAS

    getDeviceWithAlarm(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId);
    }

    getDeviceWithAlarmOO(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && dispositivo.type === 'OO');
    }

    getDeviceWithAlarmEE(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && dispositivo.type === 'EE');
    }

    getDeviceWithAlarmTT(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && dispositivo.type === 'TT');
    }

    getDeviceWithAlarmRR(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && dispositivo.type === 'RR');
    }

    existeAlarmaEnDispositvo(deviceId: number): boolean {
      const cumpleEE = this.getDeviceWithAlarmEE(deviceId);
      const cumpleTT = this.getDeviceWithAlarmTT(deviceId);
    
      return cumpleEE || cumpleTT;
    }

    getDeviceWithAlarmNivel(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && 
        (dispositivo.type === 'L1' || dispositivo.type === 'L2' || dispositivo.type === 'L3' || dispositivo.type === 'L4'));
    }

    getDeviceWithAlarmTemperaturaAlta(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && 
        (dispositivo.type === 'A1' || dispositivo.type === 'A2' || dispositivo.type === 'A3' || dispositivo.type === 'A4'));
    }

    getDeviceWithAlarmTemperaturaBaja(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && 
        (dispositivo.type === 'B1' || dispositivo.type === 'B2' || dispositivo.type === 'B3' || dispositivo.type === 'B4'));
    }

    getDeviceWithAlarmPresionAlta(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && 
        (dispositivo.type === 'C1' || dispositivo.type === 'C2' || dispositivo.type === 'C3' || dispositivo.type === 'C4'));
    }

    getDeviceWithAlarmPresionBaja(deviceId: number){
      return this.dispositivosConAlarmas.some(dispositivo => dispositivo.dev_id === deviceId && 
        (dispositivo.type === 'D1' || dispositivo.type === 'D2' || dispositivo.type === 'D3' || dispositivo.type === 'D4'));
    }

    existeAlarmaEnTanque(deviceId: number): boolean {
      const cumpleNivel = this.getDeviceWithAlarmNivel(deviceId);
      const cumpleTemperaturaAlta = this.getDeviceWithAlarmTemperaturaAlta(deviceId);
      const cumpleTemperaturaBaja = this.getDeviceWithAlarmTemperaturaBaja(deviceId);
      const cumplePresionAlta = this.getDeviceWithAlarmPresionAlta(deviceId);
      const cumplePresionBaja = this.getDeviceWithAlarmPresionBaja(deviceId);
    
      return cumpleNivel || cumpleTemperaturaAlta || cumpleTemperaturaBaja || cumplePresionAlta || cumplePresionBaja;
    }

    /*getPanelAlarmTypeForSymbol(deviceId: number): string {
      // Lógica para determinar el estilo según el estado del dispositivo
      if (this.getDeviceWithAlarmOO(deviceId)) {
        return 'desconectado';
      } else if (this.getDeviceWithAlarmEE(deviceId)) {
        return 'microSD';
      } else if (this.getDeviceWithAlarmTT(deviceId)) {
        return 'Corte de luz';
      } else if (this.getDeviceWithAlarmRR(deviceId)) {
        return 'Luz reestablecida';
      } else if (this.getDeviceWithAlarmTT(deviceId)) {
        return 'Corte de luz';
      } else if (this.getDeviceWithAlarmNivel(deviceId)) {
        return 'Nivel bajo'
      } else if (this.getDeviceWithAlarmTemperaturaAlta(deviceId)) {
        return 'Temperatura Alta';
      } else if (this.getDeviceWithAlarmTemperaturaBaja(deviceId)) {
        return 'Temperatura Baja';
      } else if (this.getDeviceWithAlarmPresionAlta(deviceId)) {
        return 'Presion Alta';
      } else if (this.getDeviceWithAlarmPresionBaja(deviceId)) {
        return 'PresionBaja';
      } else {
        return 'nada';  // Valor por defecto
      }
    }*/

  formatearFecha(fechaOriginal: string): string {
    const fecha = new Date(fechaOriginal);
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1; // ¡Atención! Los meses son indexados desde 0
    const año = fecha.getFullYear();
    const horas = fecha.getHours();
    const minutos = fecha.getMinutes();
    const segundos = fecha.getSeconds();
  
    // Asegurarse de que el día, mes, horas, minutos y segundos tengan dos dígitos
    const diaFormateado = dia < 10 ? `0${dia}` : `${dia}`;
    const mesFormateado = mes < 10 ? `0${mes}` : `${mes}`;
    const horasFormateadas = horas < 10 ? `0${horas}` : `${horas}`;
    const minutosFormateados = minutos < 10 ? `0${minutos}` : `${minutos}`;
    const segundosFormateados = segundos < 10 ? `0${segundos}` : `${segundos}`;
  
    return `${diaFormateado}-${mesFormateado}-${año} ${horasFormateadas}:${minutosFormateados}:${segundosFormateados}`;
  }

  /*Cuando el id sea el mismo en el array devicesData y en el userDevices devolveremos
  la última lectura disponible*/
  getUltimaLectura(actual_dev_id: string): string {
    for (let i = 0; i < this.userDevices.length; i++) {
      if (this.userDevices[i].id == actual_dev_id) {
        const fechaOriginal = this.userDevices[i].lastreader.created_at;
        const fechaFormateada = this.formatearFecha(fechaOriginal);
        return fechaFormateada;
      }
    }
    return "";
  }

  /*Cuando el id sea el mismo en el array devicesData y en el userDevices devolveremos
  el número de tanques activos*/
  getTanqueActivo(actual_dev_id : string):number{
    for(let i=0; i<this.userDevices.length; i++){
      if(this.userDevices[i].id == actual_dev_id){
          return this.userDevices[i].lastreader.field2;
      }
    }
    return 0;
  }

  //Función para abrir y cerrar un expansion panel
  togglePanel(panelId: number) {
    this.opened[panelId] = !this.opened[panelId];
  }

  onPageChange(event: PageEvent) {
    this.datosRecibidos2 = false; 
    this.disablePaginator = true;
    this.opened.fill(true); //Abrimos los paneles cada vez que se cambia la página
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;   
    this.devicesDataPagina = [];
    this.updateVisibleDevices();
    setTimeout(() => {
      this.disablePaginator = false;
    }, 1500);
  }

  updateVisibleDevicesActualización(){
    console.log("10 sec");
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = Math.min((this.currentPage + 1) * this.pageSize, this.userDevices.length);
    //this.visibleDevices = this.userDevices.slice(startIndex, endIndex);

    const visibleDevicesActualizados = this.userDevices.slice(startIndex, endIndex);
    //ACTUALIZAR LAS VARIABLES QUE CAMBIAN CÓMO SE VE EL PANEL DEL TITULO
    for(let i=0; i<this.visibleDevices.length; i++){
      //Actualizar las alarmas 
      this.visibleDevices[i].alarms = visibleDevicesActualizados[i].alarms;
      this.visibleDevices[i].tiposDeAlarma = this.getAlarmTypesForDevice(this.visibleDevices[i]);
    }
    this.devicesDataPagina = [];
    for (let i = startIndex; i < endIndex; i++) {
      //Conseguir las referencias de los dispositivos
      this.devicesDataPagina.push(this.userDevices[i]);
    }
    const references: string[] = this.devicesDataPagina.map((item: { dev_reference: string }) => item.dev_reference);
    const devicesReferences = references.join('-');
    this.devicesReferencesPagina = devicesReferences;
    //Actualizamos el histórico de todos los dispositivos
    const subscription = this.deviceService.getMultiHistoricRaw(this.devicesReferencesPagina,this.fechaFormateada, this.obtenerDiaSiguiente(this.fechaFormateada),"0").subscribe({
      next: resp =>{
        for(let i=0; i<resp.length; i++){
          if (this.deviceHistoryMap[resp[i].dev_reference]) {
            //ACTUALZIAR los readers_raw aunk el dispositivo ya exista ya que estamos actualizando la página
            //this.deviceHistoryMap[resp[i].dev_reference] = resp[i].readers_raw;
            this.deviceHistoryMap[resp[i].dev_reference].historico = resp[i].readers_raw;
            if(this.verificarExistenciaHistorial(this.deviceHistoryMap,resp[i].dev_reference)){
              if(resp[i].readers_raw.length !== 0){
                this.actualizarloadCharts(resp[i].dev_reference);
              }
            }
          } else{
            //this.deviceHistoryMap[resp[i].dev_reference] = resp[i].readers_raw;
            this.deviceHistoryMap[resp[i].dev_reference].historico = resp[i].readers_raw;
            if(this.verificarExistenciaHistorial(this.deviceHistoryMap,resp[i].dev_reference)){
              if(resp[i].readers_raw.length !== 0){
                this.actualizarloadCharts(resp[i].dev_reference);
              }
            }
          }
        }
      },error: (err) => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () => {}
    });
    this.deviceTodayHistorySubscriptions.push(subscription);
  }

  public getColorTemperatura(item: any): string {
    return item.tiposDeAlarma.some((tipo:any) => ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'].includes(tipo)) ? '#B20C20' : 'black';
  }

  public getColorPresion(item: any): string {
    return item.tiposDeAlarma.some((tipo:any) => ['D1', 'D2', 'D3', 'D4', 'C1', 'C2', 'C3', 'C4'].includes(tipo)) ? '#B20C20' : 'black';
  }

  public getColorNivelConsumo(item: any): string {
    return item.tiposDeAlarma.some((tipo:any) => ['L1', 'L2', 'L3', 'L4'].includes(tipo)) ? '#B20C20' : 'black';
  }

  public getColorByTipoAlarma(tipoAlarma: string): string {
    const temperaturTypes = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4'];
    const presionTypes = ['D1', 'D2', 'D3', 'D4', 'C1', 'C2', 'C3', 'C4'];
    const nivelConsumoTypes = ['L1', 'L2', 'L3', 'L4'];
    const dispositivoTypes = ['TT', 'EE'];
    const dispositivoDesconectado = ['OO'];
  
    if (temperaturTypes.includes(tipoAlarma)) {
      return '#B20C20'; 
    } else if (presionTypes.includes(tipoAlarma)) {
      return '#B20C20'; 
    } else if (nivelConsumoTypes.includes(tipoAlarma)) {
      return '#B20C20'; 
    } else if (dispositivoTypes.includes(tipoAlarma)) {
      return '#DE9200'; 
    } else if (dispositivoDesconectado.includes(tipoAlarma)) {
      return '#757575'; 
    } else {
      return 'black'; 
    }
  }
  
  getAlarmTypesForDevice(device: any): string[] {
    return device.alarms.map((alarma:any)=> alarma.type);
  }

  devolverDispositivo(dispositivoId: number){
    const dispositivo = this.userDevices.find((dispositivo:any) => dispositivo.id == dispositivoId);
    return dispositivo;
  }

  //Funcion para filtrar los establecimientos con el select
  onStatusChange() {
    //Primero poner los devices originales
    this.userDevices = this.userDevicesOriginal;
    //Poner la primera página
    this.currentPage = 0;
    const tanqueTypes = ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4', 'D1','D2', 'D3', 'D4', 'C1', 'C2', 'C3', 'C4', 'L1', 'L2', 'L3', 'L4'];
    const dispositivoTypes = ['TT', 'EE'];
    const dispositivoDesconectado = ['OO'];
    this.datosRecibidos2 = false; 
    this.disablePaginator = true;
    if(this.selectedStatus == "alarmaD"){
      const dispositivosConAlarma = this.userDevices.filter(device =>
        device.alarms.some((alarma:any) => dispositivoTypes.includes(alarma.type))
      );
      this.userDevices = dispositivosConAlarma;
    }
    if(this.selectedStatus == "alarmaT"){
      const dispositivosConAlarma = this.userDevices.filter(device =>
        device.alarms.some((alarma:any) => tanqueTypes.includes(alarma.type))
      );
      this.userDevices = dispositivosConAlarma;
    }
    if(this.selectedStatus == "desconectado"){
      const dispositivosConAlarma = this.userDevices.filter(device =>
        device.alarms.some((alarma:any) => dispositivoDesconectado.includes(alarma.type))
      );
      this.userDevices = dispositivosConAlarma;
    }
    if(this.selectedStatus == "normal"){
      const dispositivosSinAlarma = this.userDevices.filter(device =>
        device.alarms.length === 0
      );
      this.userDevices = dispositivosSinAlarma;
    }
    this.nDispositivos = this.userDevices.length;
    this.devicesDataPagina = [];
    this.updateVisibleDevicesActualizacion = false;
    this.actualizarDatosDevices();
    this.updateVisibleDevices();
    this.updateVisibleDevicesActualizacion = true;
  }

  //Cargamos el historial y los dispositivos en cada página
  updateVisibleDevices() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = Math.min((this.currentPage + 1) * this.pageSize, this.userDevices.length);
    this.visibleDevices = this.userDevices.slice(startIndex, endIndex);
    
    // Asigna el fondo a cada elemento en visibleDevices
    this.visibleDevices = this.userDevices.slice(startIndex, endIndex).map(device => ({
      ...device,
      tiposDeAlarma: this.getAlarmTypesForDevice(device),
    }));

    //console.log(this.visibleDevices);

    //Esperar a que se cargue el DOM para recuperar bien el deviceReference con document.getElementById
    setTimeout(() => {
      // Destruir los gráficos existentes antes de cargar los nuevos en la siguiente página
      this.destroyCharts();
      for (let i = startIndex; i < endIndex; i++) {
        const deviceReference = this.userDevices[i].dev_reference;
        //Conseguir las referencias de los dispositivos
        this.devicesDataPagina.push(this.userDevices[i]);
        /*if (this.deviceHistoryMap[deviceReference]) {
          if(this.verificarExistenciaHistorial(this.deviceHistoryMap,deviceReference)){
            this.loadCharts(deviceReference);
          }
        } else {
          const subscription = this.deviceService.getDeviceTodayHisrotic(deviceReference, this.fechaFormateada)
            .subscribe({
              next: (resp) => {
                this.deviceTodayHistory.push(resp);
                this.deviceHistoryMap[deviceReference] = resp;
                if(this.verificarExistenciaHistorial(this.deviceHistoryMap,deviceReference)){
                  this.loadCharts(deviceReference);
                }
              },error: (err) => {
                if (err.status == 429) {
                  this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                  this.recargarPaginaDespuesDeTiempo();
                } else {
                  this.errorMessage = err.error.message;
                }
              },complete:() => {  
              }
            });
          this.deviceTodayHistorySubscriptions.push(subscription);
        }*/
      }
      //Guardamos las referencias en una variable
      const references: string[] = this.devicesDataPagina.map((item: { dev_reference: string }) => item.dev_reference);
      const devicesReferences = references.join('-');
      this.devicesReferencesPagina = devicesReferences;
      //Llamamos el histórico de todos los dispositivos
      const subscription = this.deviceService.getMultiHistoricRaw(this.devicesReferencesPagina,this.fechaFormateada, this.obtenerDiaSiguiente(this.fechaFormateada),"0").subscribe({
        next: resp =>{
          for(let i=0; i<resp.length; i++){
            if (this.deviceHistoryMap[resp[i].dev_reference]) {
              if(this.verificarExistenciaHistorial(this.deviceHistoryMap,resp[i].dev_reference)){
                if(resp[i].readers_raw.length !== 0){
                  this.loadCharts(resp[i].dev_reference);
                }
              }
            } else{
              //this.deviceHistoryMap[resp[i].dev_reference] = resp[i].readers_raw;
              this.deviceHistoryMap[resp[i].dev_reference] = {
                historico: resp[i].readers_raw,
                tamañoHistoricoOriginal: resp[i].readers_raw.length,
                chartT: null,
                chartP: null,
                chartNC: null,
              };
              if(this.verificarExistenciaHistorial(this.deviceHistoryMap,resp[i].dev_reference)){
                if(resp[i].readers_raw.length !== 0){
                  this.loadCharts(resp[i].dev_reference);
                }
              }
            }
          }
        },error: (err) => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () => {
          this.datosRecibidos2 = true; 
        }
      });
      this.deviceTodayHistorySubscriptions.push(subscription);
    },0);
  }

  waitForDOMReady(): Promise<void> {
    return new Promise<void>((resolve) => {
      //Todo el documento HTML y sus recursos asociados están cargados
      if (document.readyState === 'complete') {
        resolve();
      } else {
        //Los datos básicos están cargados
        document.addEventListener('DOMContentLoaded', () => {
          resolve();
        });
      }
    });
  }

  /*waitForElementToExist (elementId: string, maxAttempts: number = 10, interval: number = 1000): Promise<HTMLElement | null> {
    return new Promise((resolve) => {
      let attempts = 0;
      const checkExistence = () => {
        const element = document.getElementById(elementId);
        if (element) {
          resolve(element);
        } else {
          attempts++;
  
          if (attempts < maxAttempts) {
            setTimeout(checkExistence, interval);
          } else {
            resolve(null);
          }
        }
      };
      checkExistence();
    });
  }

  waitForElementsToExist(canvasIds: string[], maxAttempts: number = 10, interval: number = 1000): Promise<Record<string, HTMLElement | null>> {
    return new Promise((resolve) => {
      const results: Record<string, HTMLElement | null> = {};
      let completedAttempts = 0;
      const checkExistence = (canvasId: string) => {
        const element = document.getElementById(canvasId);
        results[canvasId] = element;
        completedAttempts++;
        if (completedAttempts === canvasIds.length) {
          resolve(results);
        } else {
          if (completedAttempts < maxAttempts) {
            setTimeout(() => checkExistence(canvasIds[completedAttempts]), interval);
          } else {
            console.log("no");
            results[canvasId] = null;
            if (completedAttempts === canvasIds.length) {
              resolve(results);
            }
          }
        }
      };
      if (canvasIds.length > 0) {
        checkExistence(canvasIds[0]);
      } else {
        resolve(results);
      }
    });
  }*/

  todasListasConDatos<T>(...listas: T[][]): boolean {
    return listas.every(lista => lista.length > 0 && lista.some(value => value !== null));
  }

  obtenerDiaSiguiente(diaActual: string): string {
    const fechaObjeto = new Date(diaActual);
    const diaSiguiente = addDays(fechaObjeto, 1);
    return diaSiguiente.toISOString().slice(0, 10);
  }

  actualizarloadCharts(deviceReference: string) {
    const deviceHistoryHistorial = this.deviceHistoryMap[deviceReference].historico;
    const deviceHistory = this.deviceHistoryMap[deviceReference];
    const timeLabels: string [] = [];
    const temperaturaTanque1: any = [];
    const temperaturaTanque2: any = [];
    const temperaturaTanque3: any = [];
    const temperaturaTanque4: any= [];
    const temperaturaAmbiente: any = [];
    const presionTanque1: any = [];
    const presionTanque2: any = [];
    const presionTanque3: any = [];
    const presionTanque4: any = [];
    const caudalTanque1: any = [];
    const caudalTanque2: any = [];
    const caudalTanque3: any = [];
    const caudalTanque4: any = [];
    const nivelTanque1: any = [];
    const nivelTanque2: any = [];
    const nivelTanque3: any = [];
    const nivelTanque4: any = [];

    //PUSHEAR EN EL DATASET DEL CHART EL ÚLTIMO VALOR DEL deviceHistory.historial en caso de que se haya nuevos valores
    if(deviceHistory.tamañoHistoricoOriginal < deviceHistoryHistorial.length){
      console.log("Nuevo historial de: ",deviceReference);
      deviceHistory.tamañoHistoricoOriginal = deviceHistoryHistorial.length;
      const createdAt = deviceHistoryHistorial[deviceHistoryHistorial.length-1].created_at;
      //const hora = this.conseguirHoraEnFecha(createdAt);
      timeLabels.push(createdAt);
      temperaturaTanque1.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field6);
      temperaturaTanque2.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field7);
      temperaturaTanque3.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field8);
      temperaturaTanque4.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field24)
      temperaturaAmbiente.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field9);
      presionTanque1.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field3);
      presionTanque2.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field4);
      presionTanque3.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field5);
      presionTanque4.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field23)
      caudalTanque1.push((deviceHistoryHistorial[deviceHistoryHistorial.length-1].field11)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field12)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field20));
      caudalTanque2.push((deviceHistoryHistorial[deviceHistoryHistorial.length-1].field13)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field14)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field21));
      caudalTanque3.push((deviceHistoryHistorial[deviceHistoryHistorial.length-1].field15)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field16)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field22));
      caudalTanque4.push((deviceHistoryHistorial[deviceHistoryHistorial.length-1].field26)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field27)+(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field28));
      nivelTanque1.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field17);
      nivelTanque2.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field18);
      nivelTanque3.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field19);
      nivelTanque4.push(deviceHistoryHistorial[deviceHistoryHistorial.length-1].field25);

      //PUSHEAR LAS TIMELABELS YA QUE ES PARA TODAS LAS GRÁFICAS LAS MISMAS
      //deviceHistory.chartT.data.labels.push(timeLabels);

      const datasetsLabelsTemperatura = [
        ['Tª tanque 1', temperaturaTanque1[0]],
        ['Tª tanque 2', temperaturaTanque2[0]],
        ['Tª tanque 3', temperaturaTanque3[0]],
        ['Tª tanque 4', temperaturaTanque4[0]],
        ['Tª Ambiente', temperaturaAmbiente[0]]
      ]
      const datasetsLabelsPresion = [
        ['P tanque 1', presionTanque1[0]],
        ['P tanque 2', presionTanque2[0]],
        ['P tanque 3', presionTanque3[0]],
        ['P tanque 4', presionTanque4[0]],
      ]
      let caudalTanque1form = caudalTanque1[0] !== 0 ? caudalTanque1[0] : null;
      let caudalTanque2form = caudalTanque2[0] !== 0 ? caudalTanque2[0] : null;
      let caudalTanque3form = caudalTanque3[0] !== 0 ? caudalTanque3[0] : null;
      let caudalTanque4form = caudalTanque4[0] !== 0 ? caudalTanque4[0] : null;
      let nivelTanque1form = nivelTanque1[0] !== 0 ? nivelTanque1[0] : null;
      let nivelTanque2form = nivelTanque2[0] !== 0 ? nivelTanque2[0] : null;
      let nivelTanque3form = nivelTanque3[0] !== 0 ? nivelTanque3[0] : null;
      let nivelTanque4form = nivelTanque4[0] !== 0 ? nivelTanque4[0] : null;
      const datasetsLabelsNivelConsumo = [
        ['Nivel tanque 1', nivelTanque1form],
        ['Nivel tanque 2', nivelTanque2form],
        ['Nivel tanque 3', nivelTanque3form],
        ['Nivel tanque 4', nivelTanque4form],
        ['Consumo tanque 1', caudalTanque1form],
        ['Consumo tanque 2', caudalTanque2form],
        ['Consumo tanque 3', caudalTanque3form],
        ['Consumo tanque 4', caudalTanque4form],
      ]

      //DATASET DE TEMPERATURA
      for(let i = 0; i<datasetsLabelsTemperatura.length; i++){
        const currentLabel = datasetsLabelsTemperatura[i][0];
        const currentValue = datasetsLabelsTemperatura[i][1];
        //Ver si la label existe en algún dataset
        if(currentValue !== null){
          const labelExists = deviceHistory.chartT.data.datasets.some((dataset: any) => dataset.label === currentLabel);
          //console.log(currentLabel, ": ",labelExists);
          if(labelExists){
            //Si ya existe solo agrego el nuevo valor
            const matchingDataset = deviceHistory.chartT.data.datasets.find((dataset: any) => dataset.label === currentLabel);
            const pointDataTemperatura = [];
            const date = new Date (timeLabels[0]);
            pointDataTemperatura.push({
              x: date,
              y: currentValue
            });
            matchingDataset.data.push(pointDataTemperatura[0]);
            //console.log(matchingDataset);
          }
          if(!labelExists){
            const labelsLenght = deviceHistory.chartT.data.labels.length;
            //Rellenar con nullos hasta alcanzar el numero de labels, sino empieza añadiendo por el principio
            const nullValues = Array(labelsLenght - 1).fill(null);
            //Generar un color random ya que sino lo pone en gris
            const randomColor = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.5)`;
            const pointDataTemperatura = [];
            const date = new Date (timeLabels[0]);
            pointDataTemperatura.push({
              x: date,
              y: currentValue
            });
            const newDataset = {
              label: currentLabel,
              data: [...nullValues, pointDataTemperatura[0]],
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              backgroundColor: randomColor,
              borderColor: randomColor,
              fill: false,
            };
            deviceHistory.chartT.data.datasets.push(newDataset);
          }
        }
      }

      //DATASET DE PRESION
      for(let i = 0; i<datasetsLabelsPresion.length; i++){
        const currentLabel = datasetsLabelsPresion[i][0];
        const currentValue = datasetsLabelsPresion[i][1];
        //Ver si la label existe en algún dataset
        if(currentValue !== null){
          const labelExists = deviceHistory.chartP.data.datasets.some((dataset: any) => dataset.label === currentLabel);
          //console.log(currentLabel, ": ",labelExists);
          if(labelExists){
            //Si ya existe solo agrego el nuevo valor
            const matchingDataset = deviceHistory.chartP.data.datasets.find((dataset: any) => dataset.label === currentLabel);
            const pointDataPresion = [];
            const date = new Date (timeLabels[0]);
            pointDataPresion.push({
              x: date,
              y: currentValue
            });
            matchingDataset.data.push(pointDataPresion[0]);
            //console.log(matchingDataset);
          }
          if(!labelExists){
            const labelsLenght = deviceHistory.chartP.data.labels.length;
            //Rellenar con nullos hasta alcanzar el numero de labels, sino empieza añadiendo por el principio
            const nullValues = Array(labelsLenght - 1).fill(null);
            //Generar un color random ya que sino lo pone en gris
            const randomColor = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.5)`;
            const pointDataPresion = [];
            const date = new Date (timeLabels[0]);
            pointDataPresion.push({
              x: date,
              y: currentValue
            });
            const newDataset = {
              label: currentLabel,
              data: [...nullValues, pointDataPresion[0]],
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              backgroundColor: randomColor,
              borderColor: randomColor,
              fill: false,
            };
            deviceHistory.chartP.data.datasets.push(newDataset);
          }
        }
      }

      //DATASET DE NIVEL/CONSUMO
      for(let i = 0; i<datasetsLabelsNivelConsumo.length; i++){
        const currentLabel = datasetsLabelsNivelConsumo[i][0];
        const currentValue = datasetsLabelsNivelConsumo[i][1];
        //Ver si la label existe en algún dataset
        if(currentValue !== null){
          const labelExists = deviceHistory.chartNC.data.datasets.some((dataset: any) => dataset.label === currentLabel);
          //console.log(currentLabel, ": ",labelExists);
          if(labelExists){
            //Si ya existe solo agrego el nuevo valor
            const matchingDataset = deviceHistory.chartNC.data.datasets.find((dataset: any) => dataset.label === currentLabel);
            const pointDataNivelConsumo = [];
            const date = new Date (timeLabels[0]);
            pointDataNivelConsumo.push({
              x: date,
              y: currentValue
            });
            matchingDataset.data.push(pointDataNivelConsumo[0]);
            //console.log(matchingDataset);
          }
          if(!labelExists){
            const labelsLenght = deviceHistory.chartNC.data.labels.length;
            //Rellenar con nullos hasta alcanzar el numero de labels, sino empieza añadiendo por el principio
            const nullValues = Array(labelsLenght - 1).fill(null);
            let color;
            let fill;
            let yAxisID;
            if(i>3){
              yAxisID = 'y1';
              fill = true;
              color = 'rgba(204, 204, 204)';
            } else {
              yAxisID = 'y';
              fill = false;
              color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.5)`;
            }
            const pointDataNivelConsumo = [];
            const date = new Date (timeLabels[0]);
            pointDataNivelConsumo.push({
              x: date,
              y: currentValue
            });
            const newDataset = {
              label: currentLabel,
              data: [...nullValues, pointDataNivelConsumo[0]],
              borderWidth: 1,
              pointBorderWidth: 10,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 1,
              pointRadius: 0,
              backgroundColor: color,
              borderColor: color,
              yAxisID: yAxisID,
              fill: fill,
            };
            deviceHistory.chartNC.data.datasets.push(newDataset);
          }
        }
      }
        
      //UPDATE
      deviceHistory.chartT.update();
      deviceHistory.chartP.update();
      deviceHistory.chartNC.update();
    }
  }

  loadCharts(deviceReference: string) {
    setTimeout(() => {
      this.waitForDOMReady().then(() => {
        const canvasT: any = document.getElementById(deviceReference + 'T');
        const canvasP: any = document.getElementById(deviceReference + 'P');
        const canvasNC: any = document.getElementById(deviceReference + 'NC');
        const ctxT = canvasT.getContext('2d');
        const ctxP = canvasP.getContext('2d');
        const ctxNC = canvasNC.getContext('2d');

        /*console.log(canvasT);
        console.log(canvasP);
        console.log(canvasNC);*/

        const deviceHistory = this.deviceHistoryMap[deviceReference].historico;
        const timeLabels = [];
        const temperaturaTanque1 = [];
        const temperaturaTanque2 = [];
        const temperaturaTanque3 = [];
        const temperaturaTanque4 = [];
        const temperaturaAmbiente = [];
        const presionTanque1 = [];
        const presionTanque2 = [];
        const presionTanque3 = [];
        const presionTanque4 = [];
        const caudalTanque1 = [];
        const caudalTanque2 = [];
        const caudalTanque3 = [];
        const caudalTanque4 = [];
        const nivelTanque1 = [];
        const nivelTanque2 = [];
        const nivelTanque3 = [];
        const nivelTanque4 = [];

        const soloDosDecimalesConComa = (numero: any) => {
          return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
        };

        //Conseguir los historicos y los datos de Temperatura, Presión, etc. de cada dispositivo
        for(let i=0; i<deviceHistory.length; i++){
          const createdAt = deviceHistory[i].created_at;
          //const hora = this.conseguirHoraEnFecha(createdAt);
          timeLabels.push(createdAt);
          temperaturaTanque1.push(deviceHistory[i].field6);
          temperaturaTanque2.push(deviceHistory[i].field7);
          temperaturaTanque3.push(deviceHistory[i].field8);
          temperaturaTanque4.push(deviceHistory[i].field24)
          temperaturaAmbiente.push(deviceHistory[i].field9);
          presionTanque1.push(deviceHistory[i].field3);
          presionTanque2.push(deviceHistory[i].field4);
          presionTanque3.push(deviceHistory[i].field5);
          presionTanque4.push(deviceHistory[i].field23)
          caudalTanque1.push((deviceHistory[i].field11)+(deviceHistory[i].field12)+(deviceHistory[i].field20));
          caudalTanque2.push((deviceHistory[i].field13)+(deviceHistory[i].field14)+(deviceHistory[i].field21));
          caudalTanque3.push((deviceHistory[i].field15)+(deviceHistory[i].field16)+(deviceHistory[i].field22));
          caudalTanque4.push((deviceHistory[i].field26)+(deviceHistory[i].field27)+(deviceHistory[i].field28));
          nivelTanque1.push(deviceHistory[i].field17);
          nivelTanque2.push(deviceHistory[i].field18);
          nivelTanque3.push(deviceHistory[i].field19);
          nivelTanque4.push(deviceHistory[i].field25);
        }
        //console.log(this.todasListasConDatos(temperaturaTanque1,temperaturaTanque2,temperaturaTanque3,temperaturaAmbiente));
        /******************************************datasetT**************************************************/
        //Comprobamos que los datos de temperatura no estén vacios y devuelvan por lo menos algún valor no nulo
        let datasetsT = [];
        if (temperaturaTanque1.length > 0 && temperaturaTanque1.some(value => value !== null) && temperaturaTanque1.some(value => value !== undefined)) {
          const pointDataTemperatura = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataTemperatura.push({
              x: date,
              y: temperaturaTanque1[i]
            });
          }
          datasetsT.push({
            label: 'Tª tanque 1',
            data: pointDataTemperatura,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            yAxisID: 'y'
          });
        }
        if (temperaturaTanque2.length > 0 && temperaturaTanque2.some(value => value !== null) && temperaturaTanque2.some(value => value !== undefined)) {
          const pointDataTemperatura = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataTemperatura.push({
              x: date,
              y: temperaturaTanque2[i]
            });
          }
          datasetsT.push({
            label: 'Tª tanque 2',
            data: pointDataTemperatura,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
          });
        }
        if (temperaturaTanque3.length > 0 && temperaturaTanque3.some(value => value !== null) && temperaturaTanque3.some(value => value !== undefined)) {
          const pointDataTemperatura = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataTemperatura.push({
              x: date,
              y: temperaturaTanque3[i]
            });
          }
          datasetsT.push({
            label: 'Tª tanque 3',
            data: pointDataTemperatura,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
          });
        }
        if (temperaturaTanque4.length > 0 && temperaturaTanque4.some(value => value !== null) && temperaturaTanque4.some(value => value !== undefined)) {
          const pointDataTemperatura = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataTemperatura.push({
              x: date,
              y: temperaturaTanque4[i]
            });
          }
          datasetsT.push({
            label: 'Tª tanque 4',
            data: pointDataTemperatura,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
          });
        }
        if (temperaturaAmbiente.length > 0 && temperaturaAmbiente.some(value => value !== null) && temperaturaAmbiente.some(value => value !== undefined)) {
          const pointDataTemperatura = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataTemperatura.push({
              x: date,
              y: temperaturaAmbiente[i]
            });
          }
          datasetsT.push({
            label: 'Tª Ambiente',
            data: pointDataTemperatura,
            borderWidth: 1,
            borderDash: [5, 5],
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            hidden: true,
          });
        }
        /******************************************datasetT**************************************************/

        /******************************************datasetP**************************************************/
        let datasetsP = [];
        if (presionTanque1.length > 0 && presionTanque1.some(value => value !== null) && presionTanque1.some(value => value !== undefined)) {
          const pointDataPresion = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataPresion.push({
              x: date,
              y: presionTanque1[i]
            });
          }
          datasetsP.push({
            label: 'P tanque 1',
            data: pointDataPresion,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            yAxisID: 'y'
          });
        }
        if (presionTanque2.length > 0 && presionTanque2.some(value => value !== null) && presionTanque2.some(value => value !== undefined)) {
          const pointDataPresion = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataPresion.push({
              x: date,
              y: presionTanque2[i]
            });
          }
          datasetsP.push({
            label: 'P tanque 2',
            data: pointDataPresion,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
          });
        }
        if (presionTanque3.length > 0 && presionTanque3.some(value => value !== null) && presionTanque3.some(value => value !== undefined)) {
          const pointDataPresion = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataPresion.push({
              x: date,
              y: presionTanque3[i]
            });
          }
          datasetsP.push({
            label: 'P tanque 3',
            data: pointDataPresion,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
          });
        }
        if (presionTanque4.length > 0 && presionTanque4.some(value => value !== null) && presionTanque4.some(value => value !== undefined)) {
          const pointDataPresion = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataPresion.push({
              x: date,
              y: presionTanque4[i]
            });
          }
          datasetsP.push({
            label: 'P tanque 4',
            data: pointDataPresion,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            //backgroundColor: this.gradientFill3,
          });
        }
        /******************************************datasetP************************************************* */

        /******************************************datasetNC**************************************************/
        //A parte de comprobar que no son todo valores nulos también comprobamos que no sean todos cero
        let datasetsN: any[] = [];
        let datasetsC: any[] = [];
        if (nivelTanque1.length > 0 && nivelTanque1.some(value => value !== null && value !==undefined && value !== "0.00" && value !== 0)) {
          const pointDataNivel = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataNivel.push({
              x: date,
              y: nivelTanque1[i]
            });
          }
          datasetsN.push({
            yAxisID: 'y',
            label: 'Nivel tanque 1',
            data: pointDataNivel,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            borderColor: '#36A2EB',
            backgroundColor: '#9AD0F5'
          });
        }
        if (nivelTanque2.length > 0 && nivelTanque2.some(value => value !== null && value !==undefined && value !== "0.00" && value !== 0)) {
          
          const pointDataNivel = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataNivel.push({
              x: date,
              y: nivelTanque2[i]
            });
          }datasetsN.push({
            yAxisID: 'y',
            label: 'Nivel tanque 2',
            data: pointDataNivel,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            borderColor: '#FF6384',
            backgroundColor: '#FFB1C1'
          });
        }
        if (nivelTanque3.length > 0 && nivelTanque3.some(value => value !== null && value !==undefined && value !== "0.00" && value !== 0)) {
          const pointDataNivel = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataNivel.push({
              x: date,
              y: nivelTanque3[i]
            });
          }
          datasetsN.push({
            yAxisID: 'y',
            label: 'Nivel tanque 3',
            data: pointDataNivel,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            borderColor: '#FF9F40',
            backgroundColor: '#FFCF9F'
          });
        }
        if (nivelTanque4.length > 0 && nivelTanque4.some(value => value !== null && value !==undefined && value !== "0.00" && value !== 0)) {
          const pointDataNivel = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataNivel.push({
              x: date,
              y: nivelTanque4[i]
            });
          }
          datasetsN.push({
            yAxisID: 'y',
            label: 'Nivel tanque 4',
            data: pointDataNivel,
            borderWidth: 1,
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            fill: false,
            borderColor: '#FFCD56',
            backgroundColor: '#FFE6AA'
          });
        }
        if (caudalTanque1.length > 0 && caudalTanque1.some(value => value !== null && value !== 0) && caudalTanque1.some(value => value !== undefined && value !== 0)
        && caudalTanque1.some(value => !Number.isNaN(value) && value !== 0)) {
          const pointDataConsumo = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataConsumo.push({
              x: date,
              y: caudalTanque1[i]
            });
          }
          datasetsC.push({
            yAxisID: 'y1',
            hidden: false,
            label: "Consumo tanque 1",
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            borderWidth: 1,
            fill: true,
            /*fill: {
              target: 'origin',
              above: 'rgba(204, 204, 204)',
              below: 'rgba(204, 204, 204)'
            },*/
            data: pointDataConsumo,
            backgroundColor: 'rgba(204, 204, 204)'
          });
        }
        if (caudalTanque2.length > 0 && caudalTanque2.some(value => value !== null && value !== 0) && caudalTanque2.some(value => value !== undefined && value !== 0)
        && caudalTanque2.some(value => !Number.isNaN(value) && value !== 0)) {
          const pointDataConsumo = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataConsumo.push({
              x: date,
              y: caudalTanque2[i]
            });
          }
          datasetsC.push({
            yAxisID: 'y1',
            hidden: false,
            label: "Consumo tanque 2",
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            borderWidth: 1,
            fill: true,
            data: pointDataConsumo,
            backgroundColor: 'rgba(204, 204, 204)'
          });
        }
        if (caudalTanque3.length > 0 && caudalTanque3.some(value => value !== null && value !== 0) && caudalTanque3.some(value => value !== undefined && value !== 0)
        && caudalTanque3.some(value => !Number.isNaN(value) && value !== 0)) {
          const pointDataConsumo = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataConsumo.push({
              x: date,
              y: caudalTanque3[i]
            });
          }
          datasetsC.push({
            yAxisID: 'y1',
            hidden: false,
            label: "Consumo tanque 3",
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            borderWidth: 1,
            fill: true,
            data: pointDataConsumo,
            backgroundColor: 'rgba(204, 204, 204)'
          });
        }
        if (caudalTanque4.length > 0 && caudalTanque4.some(value => value !== null && value !== 0) && caudalTanque4.some(value => value !== undefined && value !== 0)
        && caudalTanque4.some(value => !Number.isNaN(value) && value !== 0)) {
          const pointDataConsumo = [];
          for(let i=0; i<timeLabels.length; i++){
            const date = new Date (timeLabels[i]);
            pointDataConsumo.push({
              x: date,
              y: caudalTanque4[i]
            });
          }
          datasetsC.push({
            yAxisID: 'y1',
            hidden: false,
            label: "Consumo tanque 4",
            pointBorderWidth: 10,
            pointHoverRadius: 10,
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            borderWidth: 1,
            fill: true,
            data: pointDataConsumo,
            backgroundColor: 'rgba(204, 204, 204)'
          });
        }
        /******************************************datasetNC**************************************************/
        /*const customTitle = {
          id: 'customTitle',
          beforeLayout: (chart: any, args: any, opts: any) => {
            if (!(opts.title && opts.title.display)) {
              return;
            }
        
            const { ctx } = chart;
            ctx.save();
        
            // Rotar el canvas
            ctx.translate(chart.width / 2, chart.options.layout.padding.top);
            ctx.rotate(-Math.PI / 2);
        
            // Verificar que opts.title y opts.title.text estén definidos
            if (opts.title.text) {
              ctx.font = opts.title.font || '18px "Helvetica Neue", Helvetica, Arial, sans-serif';
              const { width } = ctx.measureText(opts.title.text);
              chart.options.layout.padding.top = width * 1.3;
            }
          },
          afterDraw: (chart: any, args: any, opts: any) => {
            const { ctx } = chart;
        
            // Verificar que opts.title esté definido
            if (opts.title && opts.title.display) {
              ctx.restore();
        
              // Verificar que opts.title.text esté definido
              if (opts.title.text) {
                ctx.fillStyle = opts.title.color || Chart.defaults.color;
                ctx.font = opts.title.font || '18px "Helvetica Neue", Helvetica, Arial, sans-serif';
                ctx.textAlign = 'center';
                ctx.fillText(opts.title.text, chart.width / 2, chart.options.layout.padding.top - (opts.title.offsetY || 10));
              }
            }
          }
        };*/
        // Crear un nuevo gráfico Temperatura
        this.chartT = new Chart(ctxT, {
          type: 'line',
          data: {
            datasets: datasetsT
          },
          /*plugins: [customTitle],*/
          options: {
            spanGaps: this.spanGaps,
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              easing: "easeInOutBack"
            }, 
            plugins: {           
              /*title: {
                display: true,
                position: 'left',
                align:'end',
                text: 'ºC',
                font: {
                  size: 13,
                  weight: 'bold'
                },
                padding: {
                  bottom: 10
                },
              },*/
              /*customTitle: {
                y: {
                  display: true,
                  text: 'Numbers'
                }
              },*/
              tooltip: {
                usePointStyle: true,
                callbacks: {
                  labelPointStyle: function(context) {
                    return {
                        pointStyle: 'rect',
                        rotation: 0,
                    };
                  },
                  label: function(context) {
                    const label = context.dataset.label || '';
                    const value = soloDosDecimalesConComa(context.parsed.y);
                    return `${label}: ${value}`;
                  },
                }
              },
              legend: {
                position: "bottom",
                display: true,
                labels: {
                  boxWidth: 20,
                  font: {
                    size: 10
                  },
                }
              }
            },
            interaction: {
              mode: 'index',
              intersect: false,
            },
            scales: {
              y: {
                /*title: {
                  display: true,
                  align:'end',
                  text: 'ºC',
                  font: {
                    size: 13,
                    weight: 'bold'
                  },
                  padding: {
                    bottom: 10
                  },
                },*/
                beginAtZero: true,
                position: 'left',
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                },
                grid: {
                  display: false
                },
              },
              x: {
                type: 'time',
                time: {
                  // Luxon format string
                  tooltipFormat: 'dd LLLL yyyy HH:mm',
                  parser: 'yyyy-MM-dd HH:mm',
                },
                adapters: {
                  date: {
                      locale: es
                  }
                },
                ticks: {
                  padding: 5,
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  callback: function(value, index, values) {
                    const date = new Date(value);
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    return `${hours}:${minutes}`;
                  },
                },
                grid: {
                  display: false
                }
              }
            }
          },
        });
        // Crear un nuevo gráfico Presion
        this.chartP = new Chart(ctxP, {
          type: 'line',
          data: {
            datasets: datasetsP
          },
          options: {
            spanGaps: this.spanGaps,
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              easing: "easeInOutBack"
            },
            plugins: {
              tooltip: {
                usePointStyle: true,
                callbacks: {
                  labelPointStyle: function(context) {
                    return {
                        pointStyle: 'rect',
                        rotation: 0,
                    };
                  },
                  label: function(context) {
                    const label = context.dataset.label || '';
                    const value = soloDosDecimalesConComa(context.parsed.y);
                    return `${label}: ${value}`;
                  },
                }
              },
              legend: {
                position: "bottom",
                labels: {
                  boxWidth: 20,
                  font: {
                    size: 10
                  }
                }
              }
            },
            interaction: {
              mode: 'index',
              intersect: false
            },
            scales: {
              y: {
                beginAtZero: true,
                position: 'left',
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                },
                grid: {
                  display: false
                }
              },
              x: {
                type: 'time',
                time: {
                  // Luxon format string
                  tooltipFormat: 'dd LLLL yyyy HH:mm',
                  parser: 'yyyy-MM-dd HH:mm',
                },
                adapters: {
                  date: {
                      locale: es
                  }
                },
                ticks: {
                  padding: 5,
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  callback: function(value, index, values) {
                    const date = new Date(value);
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    return `${hours}:${minutes}`;
                  },
                  //autoSkip: false,
                },
                grid: {
                  display: false
                }
              }
            }
          }
        });
        // Crear un nuevo gráfico Nivel/Consumo
        this.chartNC = new Chart(ctxNC, {
          type: 'line',
          data: {
            datasets:  [...datasetsN, ...datasetsC]
          },
          options: {
            spanGaps: this.spanGaps,
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              easing: "easeInOutBack"
            },
            plugins: {
              tooltip: {
                usePointStyle: true,
                callbacks: {
                  labelPointStyle: function(context) {
                    return {
                        pointStyle: 'rect',
                        rotation: 0,
                    };
                  },
                  label: function(context) {
                    const label = context.dataset.label || '';
                    const value = soloDosDecimalesConComa(context.parsed.y);
                    return `${label}: ${value}`;
                  },
                }
              },
              legend: {
                position: "bottom",
                labels: {
                  boxWidth: 20,
                  font: {
                    size: 10
                  }
                }
              }
            },
            interaction: {
              mode: 'index',
              intersect: false
            },
            scales: {
              y: {
                beginAtZero: true,
                position: 'left',
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                },
                grid: {
                  display: false
                },
              },
              y1: { // Segundo eje Y
                beginAtZero: true,
                position: 'right', // Puedes ajustar la posición según tus necesidades
                ticks: {
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  padding: 3,
                  callback: function(value, index, values) {
                    return soloDosDecimalesConComa(value);
                  },
                },
                grid: {
                  display: false
                }
              },
              x: {
                type: 'time',
                time: {
                  // Luxon format string
                  tooltipFormat: 'dd LLLL yyyy HH:mm',
                  parser: 'yyyy-MM-dd HH:mm',
                },
                adapters: {
                  date: {
                      locale: es
                  }
                },
                ticks: {
                  padding: 5,
                  color: "rgba(0,0,0,0.5)",
                  font: {
                    size: 10,
                    weight: 'bold'
                  },
                  callback: function(value, index, values) {
                    const date = new Date(value);
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    return `${hours}:${minutes}`;
                  },
                },
                grid: {
                  display: false
                }
              }
            }
          }
        });
        
        //Guardar en una matriz para luego eliminarlos antes de cargar las nuevas
        this.charts.push(this.chartP);
        this.charts.push(this.chartT);
        this.charts.push(this.chartNC);
        this.deviceHistoryMap[deviceReference].chartT = this.chartT;
        this.deviceHistoryMap[deviceReference].chartP = this.chartP;
        this.deviceHistoryMap[deviceReference].chartNC = this.chartNC;
      });
    },0)
  }

  destroyCharts() {
    Object.values(this.charts).forEach((chart) => {
      chart.destroy();
    });
    this.charts = [];
  }

  conseguirHoraEnFecha(fecha:string) {
    const dateTimeString = fecha;
    const dateObj = new Date(dateTimeString);
    const hour = dateObj.getHours().toString().padStart(2, '0'); // Agrega ceros al principio si es necesario
    const minute = dateObj.getMinutes().toString().padStart(2, '0'); // Agrega ceros al principio si es necesario
    const timeString = `${hour}:${minute}`;
    return timeString;
  }

  verificarExistenciaHistorial(deviceHistoryMap: any, deviceReference: string): boolean {
    //console.log(deviceHistoryMap[deviceReference].historico.length);
    if(this.deviceHistoryMap[deviceReference]){
      if(this.deviceHistoryMap[deviceReference].historico){
        if(deviceHistoryMap[deviceReference].historico.length !== 0){
          return true;
        }
      }
    }
    return false;
    /*if ((deviceHistoryMap[deviceReference] && deviceHistoryMap[deviceReference].hisrotico && deviceHistoryMap[deviceReference].historico.length !== 0)) {
      return true;
    } else {
      return false;
    }*/
  }

  async abrirDialogoRecargas(enterAnimationDuration: string, exitAnimationDuration: string){
    await this.obtenerRitmosConsumos(this.dispositivosConAlarmasNivel);
    // this.dispositivosConAlarmasNivel = await this.obtenerRitmosConsumos(this.dispositivosConAlarmasNivel);
    console.log("this.dispositivosConAlarmasNivel", this.dispositivosConAlarmasNivel)
    this.dialog.open(RecargasDialog, {
      data: {
        // tanquesConAlarmasNivel: ,
        tanquesConAlarmasNivel: this.dispositivosConAlarmasNivel,
        establecimientos: this.establecimientos,
        pro_id: this.userData.pro_id
      },
      width: '800px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }

  obtenerRitmosConsumos(dispositivos: any){
      this.ritmosConsumoSubscription = this.deviceService.getRitmosConsumo().subscribe({
        next: resp =>{      
          console.log("RITMOS", resp)
          const consumptionRates = resp.consumptionRates;

          const consumptionMap = consumptionRates.reduce((acc: any, rate: any) => {
            acc[rate.tank_id] = {
              consumption_rate: rate.consumption_rate,
              prediction_days: rate.prediction_days
            };
            return acc;
          }, {});
          console.log("e", dispositivos)
          dispositivos.forEach((est: any) => {
            const tank = est.tankJson;
            const consumptionData = consumptionMap[tank.id];
        
            if (consumptionData) {
              tank.consumption_rate = consumptionData.consumption_rate;
              tank.prediction_days = consumptionData.prediction_days;
            }
          });

          if(this.userData.pro_id === 4){
            this.ordenarPorPreferencia(dispositivos)
          }else{
            dispositivos.forEach((est: { tankJson: { prediction_days: number; }; }) => {
              if (est.tankJson?.prediction_days < 0) {
                est.tankJson.prediction_days = 0;
              }
            });
            this.ordenarPorPreferencia(dispositivos)
          }
          console.log("Establecimientos con ritmo de consumo", dispositivos);
        },error:err =>{
          console.log(err,'err');
        }, complete: () => {
          
        }
      });
    }

    // Se ordena teniendo en cuenta primero los días restantes y de segundo los ritmos de consumo
    ordenarPorPreferencia(dispositivosConAlarmas: any) {
      return dispositivosConAlarmas.sort((a: { tankJson: { prediction_days: number; consumption_rate: number; }; }, b: { tankJson: { prediction_days: number; consumption_rate: number; }; }) => {
        const predA = a.tankJson?.prediction_days ?? Infinity;
        const predB = b.tankJson?.prediction_days ?? Infinity;
        const rateA = a.tankJson?.consumption_rate ?? -Infinity;
        const rateB = b.tankJson?.consumption_rate ?? -Infinity;
    
        if (predA !== predB) {
          return predA - predB;
        }
    
        return rateB - rateA;
      });
    }

  /*verificarExistenciaMap(deviceHistoryMap: any, deviceReference: string): string {
    if (deviceHistoryMap[deviceReference] && deviceHistoryMap[deviceReference][0] && deviceHistoryMap[deviceReference][0].created_at) {
      return deviceHistoryMap[deviceReference][0].created_at;
    } else {
      return "El campo no existe.";
    }
  }*/
}

@Component({
  selector: 'dialog-animations-example-dialog',
  templateUrl: 'dialog-animation-example-dialog.html',
  styleUrls: ['./dialog-animations-example-dialog.css'],
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, NgFor, NgIf, MatDividerModule, CommonModule],
})
export class DialogAnimationsExampleDialog {

  constructor(public dialogRef: MatDialogRef<DialogAnimationsExampleDialog>, 
    @Inject(MAT_DIALOG_DATA) public data: {created_at: any; dev_reference: any; dev_label: any; status: any, backgroundColor:any}[]) {}
}

// @Component({
//   selector: 'tanques-alarma-nivel-dialog',
//   templateUrl: 'tanques-alarma-nivel-dialog.html',
//   styleUrls: ['./tanques-alarma-nivel-dialog.css'],
//   standalone: true,
//   imports: [
//     MatDialogModule, 
//     MatFormFieldModule, 
//     MatInputModule, 
//     FormsModule, 
//     MatButtonModule, 
//     NgFor, 
//     NgIf, 
//     MatDividerModule, 
//     CommonModule,
//     MatIconModule
//   ],
// })
// export class TanquesConAlarmaDeNivelDialog {

//   waitAfterSave: boolean = false;
//   tanquesConAlarmasNivel: any[];
//   establecimientos: any[];
//   pedidos: any = [];
//   recargas: any = [];
//   errorMessage : string ="";

//   private agregarPedidoSubscription: Subscription | undefined;
//   private pedidosSubscription: Subscription | undefined;
//   private recargasSubscription: Subscription | undefined;

//   constructor(public dialogRef: MatDialogRef<TanquesConAlarmaDeNivelDialog>, private error429: Error429Service,
//     @Inject(MAT_DIALOG_DATA) data: any, private deviceService : DeviceService, private toastr: ToastrService) {
//       this.tanquesConAlarmasNivel = data.tanquesConAlarmasNivel;
//       this.establecimientos = data.establecimientos;
//     }

//   ngOnDestroy(): void {
//     if (this.agregarPedidoSubscription) {
//       this.agregarPedidoSubscription.unsubscribe();
//     }
//     if (this.pedidosSubscription) {
//       this.pedidosSubscription.unsubscribe();
//     }
//     if (this.recargasSubscription) {
//       this.recargasSubscription.unsubscribe();
//     }
//   }

//   recargarPaginaDespuesDeTiempo() {
//     this.error429.setError(true);
//     window.location.reload();
//   }


//   cargarPedidosyRecargas(){
//     //const start = "2015-01-01"
//     return new Promise<void>((resolve, reject) => {
//       const currentDate = new Date();
//       const start = new Date();
//       currentDate.setDate(currentDate.getDate() + 1);
//       // Coger los pedidos desde el día de hoy a un año atras
//       start.setDate(currentDate.getDate() - 365);
//       console.log(start.toISOString().slice(0, 10))
//       this.pedidosSubscription = this.deviceService.getPedidos(start.toISOString().slice(0, 10),currentDate.toISOString().slice(0, 10)).subscribe({
//         next:resp =>{
//           this.pedidos = resp.orders;
//           this.pedidos.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
//         },error:err =>{
//           if (err.status == 429) {
//             this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
//             this.recargarPaginaDespuesDeTiempo();
//           } else {
//             this.errorMessage = err.error.message;
//           }
//           reject(err);
//         }, complete:()=>{
//           const establecimientosIDs: any = [];
//           for(let x = 0; x < this.establecimientos.length; x++){
//             establecimientosIDs.push(this.establecimientos[x].id);
//           }
//           const recargasData = new FormData();
//           recargasData.append('establishments', JSON.stringify(establecimientosIDs));
//           this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
//             next: resp => {
//               this.recargas = resp.charges;
//               this.recargas.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
//             },error: err => {
//               if (err.status == 429) {
//                 this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
//                 this.recargarPaginaDespuesDeTiempo();
//               } else {
//                 this.errorMessage = err.error.message;
//               }
//               reject(err);
//             },complete: () => {
//               resolve();
//             }
//           });
//         } 
//       });
//     })
//   }

//   async recargarTanque(estID: any, tankID: any){
//     this.waitAfterSave = false;
//     let hacerPedido: boolean = false;
//     let mensajeDeErrorPersonalizado = "Ya existe el pedido";
    
//     await this.cargarPedidosyRecargas()

//     // Comprobar que si el pedido ya se ha realizado y no se ha recibido ninguna recarga
//       const pedidosConTanqueID = this.pedidos.filter((pedido: any) => pedido.tank_id == tankID);
//       const pedidoMasAntiguo = pedidosConTanqueID[pedidosConTanqueID.length - 1];
      
//       const recargasConTanqueID = this.recargas.filter((recarga: any) => recarga.tank_id == tankID);
//       const recargaMasAntigua = recargasConTanqueID[recargasConTanqueID.length - 1];

//       if(recargasConTanqueID.length == 0 && pedidosConTanqueID.length < 0){
//         hacerPedido = false;
//       }
//       if(recargasConTanqueID.length > 0){
//         if(pedidoMasAntiguo){
//           if(pedidoMasAntiguo.created_at <= recargaMasAntigua.created_at){
//             hacerPedido = true;
//           } else {
//             hacerPedido = false;
//           }
//         } else {
//           hacerPedido = true;
//         }
//       }

//     if(!hacerPedido){
//       if (!this.waitAfterSave) {
//         this.waitAfterSave = true;
//       }
//       setTimeout(() => {
//         this.waitAfterSave = false;
//       },4500)
//       this.toastr.error(mensajeDeErrorPersonalizado, 'Error', {
//         timeOut: 4500,
//         progressBar: true,
//         titleClass: 'toast-family-font'
//       });
//     } else {
//       const pedido = new FormData();
//       pedido.append('_method', "PUT");
//       pedido.append('establishment_id', estID.toString());
//       pedido.append('tank_id', tankID.toString());
      
//       this.agregarPedidoSubscription = this.deviceService.createPedido(pedido).subscribe({
//         next:resp =>{
//           console.log(resp);
//         }, error: err => {
//           if (!this.waitAfterSave) {
//             this.waitAfterSave = true;
//           }
//           setTimeout(() => {
//             this.waitAfterSave = false;
//           },4500)
//           this.toastr.error("Acción no permitida", 'Error', {
//             timeOut: 4500,
//             progressBar: true,
//             titleClass: 'toast-family-font'
//           });
//         }, complete: () => {
//           this.toastr.success('¡Pedido solicitado!','Éxito',{
//             timeOut: 4500,
//             progressBar: true,
//             titleClass: 'toast-family-font'
//           });
//           if (!this.waitAfterSave) {
//             this.waitAfterSave = true;
//           }
//           setTimeout(() => {
//             this.waitAfterSave = false;
//           },4500)
//         }
//       });
//     }
//     }
// }

@Component({
  selector: 'recargas-dialog',
  templateUrl: 'recargas-dialog.html',
  styleUrls: ['./recargas-dialog.css'],
  standalone: true,
  imports: [
    MatDialogModule, 
    MatFormFieldModule, 
    MatInputModule, 
    FormsModule, 
    MatButtonModule, 
    NgFor, 
    NgIf, 
    MatDividerModule, 
    CommonModule,
    MatIconModule
  ],
})
export class RecargasDialog {

  waitAfterSave: boolean = false;
  tanquesConAlarmasNivel: any[];
  establecimientos: any[];
  pedidos: any = [];
  recargas: any = [];
  errorMessage : string ="";
  pro_id: any;

  private agregarPedidoSubscription: Subscription | undefined;
  private pedidosSubscription: Subscription | undefined;
  private recargasSubscription: Subscription | undefined;

  constructor(public dialogRef: MatDialogRef<RecargasDialog>, @Inject(MAT_DIALOG_DATA) data: any, private dialog: MatDialog,
  private deviceService : DeviceService, private toastr: ToastrService, private error429: Error429Service) {
   console.log("Dta", data)
    this.tanquesConAlarmasNivel = data.tanquesConAlarmasNivel;
    this.establecimientos = data.establecimientos;
    this.pro_id = data.pro_id
  }

  ngOnDestroy(): void {
    this.limpiarSeleccion();
    if (this.agregarPedidoSubscription) {
      this.agregarPedidoSubscription.unsubscribe();
    }
    if (this.pedidosSubscription) {
      this.pedidosSubscription.unsubscribe();
    }
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    }
  }

  changeDotToComma(value: any): string {
    if (value === null || value === undefined || isNaN(Number(value))) {
      return value; // Devuelve el valor original si no es un número
    }
  
    return Number(value).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  limpiarSeleccion(): void {
    this.tanquesConAlarmasNivel.forEach(tanque => {
      tanque.seleccionado = false;
    });
  }

  cargarPedidosyRecargas(){
    //const start = "2015-01-01"
    return new Promise<void>((resolve, reject) => {
      const currentDate = new Date();
      const start = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      // Coger los pedidos desde el día de hoy a un año atras
      start.setDate(currentDate.getDate() - 365);
      console.log(start.toISOString().slice(0, 10))
      this.pedidosSubscription = this.deviceService.getPedidos(start.toISOString().slice(0, 10),currentDate.toISOString().slice(0, 10)).subscribe({
        next:resp =>{
          this.pedidos = resp.orders;
          this.pedidos.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete:()=>{
          const establecimientosIDs: any = [];
          for(let x = 0; x < this.establecimientos.length; x++){
            establecimientosIDs.push(this.establecimientos[x].id);
          }
          const recargasData = new FormData();
          recargasData.append('establishments', JSON.stringify(establecimientosIDs));
          this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
            next: resp => {
              this.recargas = resp.charges;
              this.recargas.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
            },error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
              reject(err);
            },complete: () => {
              resolve();
            }
          });
        } 
      });
    })
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  async recargarTanque(estID: any, tankID: any){
    this.waitAfterSave = false;
    let hacerPedido: boolean = false;
    let mensajeDeErrorPersonalizado = "Ya existe el pedido";

    await this.cargarPedidosyRecargas()
    // Comprobar que si el pedido ya se ha realizado y no se ha recibido ninguna recarga
      const pedidosConTanqueID = this.pedidos.filter((pedido: any) => pedido.tank_id == tankID);
      const pedidoMasAntiguo = pedidosConTanqueID[pedidosConTanqueID.length - 1];
      const recargasConTanqueID = this.recargas.filter((recarga: any) => recarga.tank_id == tankID);
      const recargaMasAntigua = recargasConTanqueID[recargasConTanqueID.length - 1];

      // Si no hay recargas ni pedidos, se hace
      if (!recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si hay un pedido pero no recarga, NO se hace
      else if (!recargaMasAntigua && pedidoMasAntiguo) {
        hacerPedido = false;
      }
      // Si hay recarga pero no hay pedidos, se hace
      else if (recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si la ultima recarga es más reciente o igual al ultimo pedido, se hace
      else if (recargaMasAntigua.created_at >= pedidoMasAntiguo.created_at) {
        hacerPedido = true;
      }
      // Si el último pedido fue después de la última recarga, NO se hace
      else {
        hacerPedido = false;
      }

    if(!hacerPedido){
      if (!this.waitAfterSave) {
        this.waitAfterSave = true;
      }
      setTimeout(() => {
        this.waitAfterSave = false;
      },4500)
      this.toastr.error(mensajeDeErrorPersonalizado, 'Error', {
        timeOut: 4500,
        progressBar: true,
        titleClass: 'toast-family-font'
      });
    } else {
      const pedido = new FormData();
      pedido.append('_method', "PUT");
      pedido.append('establishment_id', estID.toString());
      pedido.append('tank_id', tankID.toString());
      pedido.forEach((value, key) => console.log(key, value));
      this.agregarPedidoSubscription = this.deviceService.createPedido(pedido).subscribe({
        next:resp =>{
          // console.log(resp);
        }, error: err => {
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
          }
          setTimeout(() => {
            this.waitAfterSave = false;
          },4500)
          if(err.error.status == 401){
            this.toastr.error("Acción no permitida", 'Error', {
              timeOut: 4500,
              progressBar: true,
              titleClass: 'toast-family-font'
            });
          } else {
            if(err.error.error){
              this.toastr.error(err.error.error, 'Error', {
                timeOut: 4500,
                progressBar: true,
                titleClass: 'toast-family-font'
              });
            } else {
              this.toastr.error('', 'Error', {
                timeOut: 4500,
                progressBar: true,
                titleClass: 'toast-family-font'
              });
            }
          }
        }, complete: () => {
          this.toastr.success('¡Pedido solicitado!','Éxito',{
            timeOut: 4500,
            progressBar: true,
            titleClass: 'toast-family-font'
          });
          
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
          }
          setTimeout(() => {
            this.waitAfterSave = false;
          },4500)
        }
      });
    }
  }

  toggleSeleccion(alarma: any) {
    alarma.seleccionado = !alarma.seleccionado;
  }

  tanquesSeleccionados(): any[] {
    return this.tanquesConAlarmasNivel.filter(t => t.seleccionado);
  }

  recargarSeleccionados() {
    const seleccionados = this.tanquesSeleccionados();
    console.log("Seleccionados", seleccionados)
    this.dialog.open(RealizarRecargaDialog, {
      width: '400px',
      data: { 
        total: seleccionados.length,
        seleccionados: seleccionados,
        establecimientos: this.establecimientos,
      }
    });
  }
}


@Component({
  selector: 'realizar-recarga-dialog',
  templateUrl: 'realizar-recarga-dialog.html',
  styleUrls: ['./realizar-recarga-dialog.css'],
  standalone: true,
  imports: [
    MatDialogModule, 
    MatFormFieldModule, 
    MatInputModule, 
    FormsModule, 
    MatButtonModule, 
    NgFor, 
    NgIf, 
    MatDividerModule, 
    CommonModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatProgressBarModule
  ],
})
export class RealizarRecargaDialog {

  procesados = 0;
  totalSeleccionados = 0;
  seleccionados: any;
  progresado = 0;
  establecimientos: any[];
  pedidosHechos: any = [];
  errores: any = [];
  recargados: any = [];
  pedidos: any = [];
  recargas: any = [];
  errorMessage : string ="";
  titulo = "Enviando pedidos"

  private agregarPedidoSubscription: Subscription | undefined;
  private pedidosSubscription: Subscription | undefined;
  private recargasSubscription: Subscription | undefined;

  constructor(public dialogRefRealizarRecarga: MatDialogRef<RealizarRecargaDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private deviceService : DeviceService, private error429: Error429Service){
    this.totalSeleccionados = data.total;
    this.establecimientos = data.establecimientos;
    this.seleccionados = data.seleccionados;
    this.iniciarRecarga();
  }

  async iniciarRecarga() {
    for (let index = 0; index < this.seleccionados.length; index++) {
      const tanque = this.seleccionados[index];
      await this.recargarTanque(tanque.tankJson.custom_num, tanque.est_name,  tanque.est_id, tanque.tankJson.id, index);
    }
    setTimeout(() => {
      this.titulo = "Pedidos enviados";
    }, 300);
  }
  
  ngOnDestroy(): void {
    if (this.agregarPedidoSubscription) {
      this.agregarPedidoSubscription.unsubscribe();
    }
    if (this.pedidosSubscription) {
      this.pedidosSubscription.unsubscribe();
    }
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  cargarPedidosyRecargas(){
    //const start = "2015-01-01"
    return new Promise<void>((resolve, reject) => {
      const currentDate = new Date();
      const start = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      // Coger los pedidos desde el día de hoy a un año atras
      start.setDate(currentDate.getDate() - 365);
      console.log(start.toISOString().slice(0, 10))
      this.pedidosSubscription = this.deviceService.getPedidos(start.toISOString().slice(0, 10),currentDate.toISOString().slice(0, 10)).subscribe({
        next:resp =>{
          this.pedidos = resp.orders;
          this.pedidos.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
          reject(err);
        }, complete:()=>{
          const establecimientosIDs: any = [];
          for(let x = 0; x < this.establecimientos.length; x++){
            establecimientosIDs.push(this.establecimientos[x].id);
          }
          const recargasData = new FormData();
          recargasData.append('establishments', JSON.stringify(establecimientosIDs));
          this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
            next: resp => {
              this.recargas = resp.charges;
              this.recargas.sort((a:any, b:any) => a.created_at.localeCompare(b.created_at));
            },error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
              reject(err);
            },complete: () => {
              resolve();
            }
          });
        } 
      });
    })
  }

  async recargarTanque(numTank: any, estName:any, estID: any, tankID: any, index: any){
    this.procesados = index + 1;
    let hacerPedido: boolean = false;

    await this.cargarPedidosyRecargas()

      const pedidosConTanqueID = this.pedidos.filter((pedido: any) => pedido.tank_id == tankID);
      const pedidoMasAntiguo = pedidosConTanqueID[pedidosConTanqueID.length - 1];
      
      const recargasConTanqueID = this.recargas.filter((recarga: any) => recarga.tank_id == tankID);
      const recargaMasAntigua = recargasConTanqueID[recargasConTanqueID.length - 1];

      // Si no hay recargas ni pedidos, se hace
      if (!recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si hay un pedido pero no recarga, NO se hace
      else if (!recargaMasAntigua && pedidoMasAntiguo) {
        hacerPedido = false;
      }
      // Si hay recarga pero no hay pedidos, se hace
      else if (recargaMasAntigua && !pedidoMasAntiguo) {
        hacerPedido = true;
      }
      // Si la ultima recarga es más reciente o igual al ultimo pedido, se hace
      else if (recargaMasAntigua.created_at >= pedidoMasAntiguo.created_at) {
        hacerPedido = true;
      }
      // Si el último pedido fue después de la última recarga, NO se hace
      else {
        hacerPedido = false;
      }

    if(!hacerPedido){
      this.pedidosHechos.push({ numTank: numTank, nombre: estName });
      this.progresado = (this.procesados / this.totalSeleccionados) * 100;
    } else {
      const pedido = new FormData();
      pedido.append('_method', "PUT");
      pedido.append('establishment_id', estID.toString());
      pedido.append('tank_id', tankID.toString());
      pedido.forEach((value, key) => console.log(key, value));
      this.agregarPedidoSubscription = this.deviceService.createPedido(pedido).subscribe({
        next:resp =>{
          console.log(resp);
          this.recargados.push({ numTank: numTank, nombre: estName });
          this.progresado = (this.procesados / this.totalSeleccionados) * 100;
        }, error: err => {
          this.errores.push({ numTank: numTank, nombre: estName });
          this.progresado = (this.procesados / this.totalSeleccionados) * 100;
        }, complete: () => {
        }
      });
    }
  }

}